module.exports = __webpack_public_path__ + "static/media/GOV-LOGO.98d7c6df.png";